import React from 'react';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import  Upload from 'rc-upload';


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        
        marginRight: "auto",
        color: "green"
    }
});


function getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}

class Uploader extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = { 
            pid:-1,
            buttonText:'',
            
           
        }

        this.uploadgeom = this.props.uploadgeom.bind(this);
    }

    data = {
        fileArr:{
            base64:[],
            size: [],
            files:{},
            extension:[],
            name:[]
        },
        pid:-1
    };

    uploaderProps =  {
        action: '', 
        headers: { 
        },
        multiple: true,
        beforeUpload(file) {
          console.log('beforeUpload', file.name);
        },
        onStart: (file) => {
            var d = this.data;
            d.fileArr.files = file;
            d.pid = this.state.pid;
            
            d.fileArr.name.push(file.name);
            d.fileArr.size.push(file.size);
            d.fileArr.extension.push(file.type);
            let that = this;
            getBase64(file, function (result) {
                console.log(result)
                d.fileArr.base64.push(result);
                that.uploadgeom(d); 
            })
            /*
            for (let i = 0; i <d.fileArr.files.length; i++) {
                let da = d.fileArr.files[i];
                 new Promise(resolve => {
                    
                }).then(res=>{
                    
                
        console.log(this.state.pid);
        console.log(d);  
                }); 
    
                
            }
/*
         (async function loop() {

            
         
            
        })();

*/
            console.log('onStart', file);
          // this.refs.inner.abort(file);
        },
        onSuccess(file) {
          console.log('onSuccess', file);
        },
        onProgress(step, file) {
          console.log('onProgress', Math.round(step.percent), file.name);
        },
        onError(err) {
          console.log('onError', err);
        },
      };
    


    static getDerivedStateFromProps(props, state) {
        let update = { 
        };  
        //this.setState({ page: nextProps.page }); 
        if (props.pid !== state.pid) { 
            update.pid= props.pid;
           
        }

        if(props.buttonText !== state.buttonText){
            update.buttonText = props.buttonText;
        }

        return update;
    }

render(){
    const { classes, pid} = this.props;
    const {buttonText } = this.state;
    console.log(pid);
    return(
        
                    <Button style={{ marginLeft: '10px' }}     variant="contained" color="secondary" className={classes.button} >  
    <Upload
            {...this.uploaderProps} 
            id="uploader"
            component="div"
            style={{ display: 'inline-block' }}
            
          ><a>{buttonText}
              </a></Upload>
              </Button>
    )}

}


export default withStyles(styles)(Uploader);


// WEBPACK FOOTER //
// ./src/components/Uploader.js